import styled, { DefaultTheme } from 'styled-components/macro';

import Button from 'components/Button/Button';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const getPopupContentStyle = (theme: DefaultTheme, isMobile: boolean) => ({
  width: isMobile ? '100%' : '480px',
  height: '100%',
  minHeight: isMobile ? 'auto' : '520px',
  maxHeight: isMobile ? 'none' : '700px',
  padding: '1.5rem 0.875rem',
  backgroundColor: theme.colors.white,
  overflowY: 'auto',
});

export const PopupHeaderStyled = styled(FlexContainer)`
  position: relative;
`;

export const NotificationsWrapStyled = styled(FlexContainer)`
  position: relative;
  transition: height 0.2s linear;
`;

export const FilterWrapStyled = styled(FlexContainer)`
  margin-right: 2.25rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin: 0;
    }
  `}
`;

export const FilterTextStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant8};
`;

export const ToggleWrapStyled = styled(FlexContainer)`
  margin-left: 0.375rem;
`;

export const MessageWrapStyled = styled.div`
  width: 90%;
  margin: 5rem auto 0;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 70%;
    }
  `}
`;

export const MarkAsReadWrapStyled = styled(FlexContainer)`
  position: absolute;
  top: 28px;
  right: 0;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      top: 30px;
    }
  `}
`;

export const MarkAsReadBtnStyled = styled(Button)`
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  padding-right: 0.5rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding-right: 0;
    }
  `}
`;

export const NotificationsLoaderStyled = styled.div`
  height: 100%;
  margin-top: 1.125rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-top: 0.625rem;
    }
  `}
`;

export const NotificationsListStyled = styled.ul`
  margin-top: 1.125rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-top: 0.625rem;
    }
  `}
`;

export const NotificationsListItemStyled = styled.li`
  padding: 0.5rem 0;
`;

export const NotificationContentWrapStyled = styled(FlexContainer)`
  flex: 1;
`;

export const EmailReadIconWrapStyled = styled.div`
  position: relative;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    position: absolute;
    top: 4px;
    right: 0;
    border-radius: ${({ theme }) => theme.radius.half};
    background-color: ${({ theme }) => theme.colors.highlight.variant5};
  }
`;

export const NotificationContentStyled = styled(FlexContainer)`
  flex: 1;
  margin-left: 0.375rem;
  cursor: pointer;
`;

export const NotificationSentDateStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant8};
  margin-bottom: 0.125rem;
`;

export const NotificationRoNumberStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant8};
  margin-top: 0.125rem;
`;

export const NotificationButtonWrapStyled = styled.div`
  position: relative;
  cursor: pointer;

  svg path {
    transition: fill 0.3s;
  }

  @media (hover: hover) {
    &:hover {
      svg path {
        fill: ${({ theme }) => theme.colors.secondary.variant5};
      }
    }
  }
`;

export const NotificationsAmountWrapStyled = styled.div`
  position: absolute;
  top: -3px;
  right: 0;
  padding: 0.125rem 0.375rem;
  background-color: ${({ theme }) => theme.colors.highlight.variant5};
  border-radius: ${({ theme }) => theme.radius.xl};
  z-index: 1;
`;

export const NotificationButtonStyled = styled(ButtonIcon)`
  border-radius: 0;

  svg {
    transform: rotate(45deg);
  }
`;
